/** Browser persistence behind the pure layer's `Storage` interface: localStorage, failing soft. */

import type { Storage } from '../meta/api';

export const browserStorage: Storage = {
  load(key) {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  save(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch {
      // Private mode or a full quota: the game still plays, it just will not remember.
    }
  },
};
